import {
  Box,
  Tab,
  TabProps,
  Tabs,
  TabsProps,
  Theme,
  Tooltip,
} from '@mui/material';

interface PageTabProps {
  tabs: (TabProps & { tooltip?: string })[];
  selectedTab: TabsProps['value'];
  onChange: TabsProps['onChange'];
}

export const PageTabs = ({ tabs, selectedTab, onChange }: PageTabProps) => {
  return (
    <Box sx={[styles.container]}>
      <Tabs
        sx={{ height: 'auto', minHeight: 0 }}
        value={selectedTab}
        onChange={onChange}
        variant="scrollable"
        slotProps={{
          root: { sx: { overflowY: 'visible' } },
          scroller: { sx: { overflowY: 'visible' } },
        }}
        TabIndicatorProps={{ sx: styles.tabIndicator }}>
        {tabs.map(tab =>
          tab.tooltip ? (
            <TabWithTooltip
              tooltipTitle={tab.tooltip}
              key={tab.value}
              value={tab.value}
              label={tab.label}
              disabled={tab.disabled}
              disableRipple
              sx={styles.tabRoot}
            />
          ) : (
            <Tab
              key={tab.value}
              value={tab.value}
              label={tab.label}
              disabled={tab.disabled}
              disableRipple
              sx={styles.tabRoot}
            />
          ),
        )}
      </Tabs>
    </Box>
  );
};

interface TabWithTooltipProps extends TabProps {
  tooltipTitle: string;
}

export const TabWithTooltip = ({
  tooltipTitle,
  ...restTabProps
}: TabWithTooltipProps) => {
  return (
    <Tooltip title={tooltipTitle}>
      <Tab {...restTabProps} />
    </Tooltip>
  );
};

const styles = {
  container: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    borderBottom: `1px solid ${theme.palette.grey100}`,
  }),
  tabIndicator: {
    height: 5,
    width: '100%',
    backgroundColor: 'primary.main',
  },
  tabRoot: (theme: Theme) => ({
    ...theme.typography.body1,
    textTransform: 'none',
    alignItems: 'flex-start',
    py: 0,
    px: 1,
    mr: 2,
    minWidth: 48,
    opacity: 1,
    overflow: 'visible',
    '&.Mui-selected': {
      ...theme.typography.body1SemiBold,
      opacity: 1,
    },
    '&.MuiTab-root': {
      py: 1,
      minHeight: 0,
      lineHeight: 1.8,
    },
    '& span': {
      alignItems: 'flex-start',
      width: 'fit-content',
    },
  }),
};
